/**
 * Card Swatches v1777904513 — Collection page variant image swap
 * + Auto-matches collection filters to card swatches
 */
(function () {
  'use strict';

  function extractSeatNumber(text) {
    var m = text.match(/^(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function seatMatches(filterValue, swatchValue) {
    var filterNum = extractSeatNumber(filterValue);
    if (filterNum === 0) return filterValue === swatchValue;
    var swatchNum = extractSeatNumber(swatchValue);
    if (swatchNum === 0) return false;
    if (filterNum === swatchNum) return true;
    var rangeMatch = swatchValue.match(/^(\d+)-(\d+)/);
    if (rangeMatch) {
      var lo = parseInt(rangeMatch[1], 10);
      var hi = parseInt(rangeMatch[2], 10);
      if (filterNum >= lo && filterNum <= hi) return true;
    }
    return false;
  }

  function syncFiltersToSwatches() {
    var params = new URLSearchParams(window.location.search);
    var seatFilters = [];
    var otherFilters = [];

    params.forEach(function (value, key) {
      var decoded = decodeURIComponent(value);
      if (key === 'filter.p.m.custom.seats') {
        seatFilters.push(decoded);
      } else if (key.indexOf('filter.p.m.custom.') === 0) {
        otherFilters.push(decoded);
      }
    });

    if (seatFilters.length === 0 && otherFilters.length === 0) return;

    document.querySelectorAll('.card-swatches').forEach(function (swatchContainer) {
      var matched = false;

      if (seatFilters.length > 0) {
        // Check text pills
        var pills = swatchContainer.querySelectorAll('.card-swatches__text');
        for (var p = 0; p < pills.length; p++) {
          if (matched) break;
          var btnValue = pills[p].textContent.trim();
          for (var i = 0; i < seatFilters.length; i++) {
            if (seatMatches(seatFilters[i], btnValue) && !pills[p].classList.contains('card-swatches__text--active')) {
              triggerSwatchClick(pills[p]);
              matched = true;
              break;
            }
          }
        }

        // Check dropdowns
        if (!matched) {
          var selects = swatchContainer.querySelectorAll('.card-swatches__select');
          for (var s = 0; s < selects.length; s++) {
            if (matched) break;
            var select = selects[s];
            for (var i = 0; i < select.options.length; i++) {
              var optText = select.options[i].textContent.trim();
              for (var j = 0; j < seatFilters.length; j++) {
                var filterNum = extractSeatNumber(seatFilters[j]);
                if (filterNum > 0 && optText.match(new RegExp('^' + filterNum + '椅'))) {
                  if (select.selectedIndex !== i) {
                    select.selectedIndex = i;
                    var cardId = select.dataset.cardId;
                    var imageUrl = select.options[i].dataset.variantImage;
                    if (imageUrl) swapCardImage(cardId, imageUrl);
                  }
                  matched = true;
                  break;
                }
              }
              if (matched) break;
            }
          }
        }
      }

      if (!matched && otherFilters.length > 0) {
        var pills = swatchContainer.querySelectorAll('.card-swatches__text');
        for (var p = 0; p < pills.length; p++) {
          if (matched) break;
          var btnValue = pills[p].textContent.trim();
          if (otherFilters.indexOf(btnValue) > -1 && !pills[p].classList.contains('card-swatches__text--active')) {
            triggerSwatchClick(pills[p]);
            matched = true;
          }
        }
      }
    });
  }

  function triggerSwatchClick(btn) {
    var cardId = btn.dataset.cardId;
    var imageUrl = btn.dataset.variantImage;

    var group = btn.closest('.card-swatches__group');
    if (group) {
      group.querySelectorAll('.card-swatches__swatch--active, .card-swatches__text--active').forEach(function (el) {
        el.classList.remove('card-swatches__swatch--active', 'card-swatches__text--active');
      });
    }
    btn.classList.add(btn.classList.contains('card-swatches__swatch') ? 'card-swatches__swatch--active' : 'card-swatches__text--active');

    if (imageUrl) swapCardImage(cardId, imageUrl);
  }

  function handleSwatchClick(e) {
    var btn = e.target.closest('.card-swatches__swatch, .card-swatches__text');
    if (!btn) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    triggerSwatchClick(btn);
  }

  function handleDropdownChange(e) {
    var select = e.target.closest('.card-swatches__select');
    if (!select) return;
    var cardId = select.dataset.cardId;
    var selected = select.options[select.selectedIndex];
    var imageUrl = selected ? selected.dataset.variantImage : '';
    if (imageUrl) swapCardImage(cardId, imageUrl);
  }

  function swapCardImage(cardId, imageUrl) {
    var card = document.getElementById(cardId);
    if (!card) return;
    var img = card.querySelector('.card__media .media img:first-child');
    if (!img) return;
    img.style.transition = 'opacity 0.25s ease';
    img.style.opacity = '0.4';
    var newImg = new Image();
    newImg.onload = function () {
      img.src = imageUrl;
      img.srcset = '';
      img.style.opacity = '1';
    };
    newImg.onerror = function () {
      img.style.opacity = '1';
    };
    newImg.src = imageUrl;
    setTimeout(function () {
      if (img.style.opacity === '0.4') {
        img.src = imageUrl;
        img.srcset = '';
        img.style.opacity = '1';
      }
    }, 400);
  }

  function init() {
    document.addEventListener('click', handleSwatchClick);
    document.addEventListener('change', handleDropdownChange);

    // Run on initial page load
    syncFiltersToSwatches();

    // Hook into Shopify's facets.js URL changes (pushState after AJAX filter)
    var origPushState = history.pushState;
    history.pushState = function () {
      origPushState.apply(history, arguments);
      // Delay to let facets.js finish replacing DOM
      setTimeout(syncFiltersToSwatches, 500);
      setTimeout(syncFiltersToSwatches, 1500);
    };

    // Also catch browser back/forward
    window.addEventListener('popstate', function () {
      setTimeout(syncFiltersToSwatches, 500);
      setTimeout(syncFiltersToSwatches, 1500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
